import React from 'react';
import { ChangeRequestAttachment, BuyerOfferAttachment } from '@/types';
import AttachmentList from '@/components/AttachmentList/AttachmentList';
import { AttachmentListProps } from '@/components/AttachmentList';
import { getOpenBuyerOfferAttachmentUrl } from '@/services/buyer-offers';


const BuyerOfferAttachmentList: React.FC<AttachmentListProps<ChangeRequestAttachment>> = ({...rest}) => { 
    return <AttachmentList<BuyerOfferAttachment> {...rest} urlGenerator={att=> getOpenBuyerOfferAttachmentUrl(att.id)  } />
}

export default BuyerOfferAttachmentList;